<template>
  <div class="container-main bg-light">
    <div class="form-row">
      <div class="col-12 col-12 px-4 py-3">
        <label class="mb-2">
          {{ $t('message.typedeletetoconfirm', { code }) }}
          <a
            v-if="learnmoreLink"
            :href="learnmoreLink"
            target="_blank"
          >
            {{ $t('button.learnmore') }}
            <i class="fas fa-external-link-alt"/>
          </a>
        </label>
        <input
          v-model="input"
          :class="inputClass"
          type="text"
          class="form-control"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  'name': 'TypeToConfirmDelete',

  props: {
    learnmoreLink: {
      type: String,
      default: null,
    },
    code: {
      type: String,
      default: 'delete',
    },
  },

  data () {
    return {
      input: '',
    }
  },

  computed: {
    isValid () {
      return this.input.trim().toLowerCase() === this.code
    },

    inputClass () {
      const { input, isValid } = this
      return [
        { 'is-valid': isValid && input.trim().length > 0 },
        { 'is-invalid': !isValid && input.trim().length > 0 },
      ]
    },
  },

  watch: {
    isValid (value) {
      this.$emit('update:isConfirmed', value)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/custom/TypeToConfirmDelete.vue